import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { AdminScreen } from "../features/admin/components/AdminScreen.tsx";
import { useAuthStore } from "../features/auth/store.ts";
import { isAdminEmail } from "../lib/admins.ts";

function AdminGuard() {
  const nav = useNavigate();
  const email = useAuthStore((s) => s.user?.email ?? s.email);
  const initialized = useAuthStore((s) => s.initialized);

  const allowed = isAdminEmail(email);

  useEffect(() => {
    if (initialized && !allowed) nav({ to: "/dashboard" });
  }, [initialized, allowed, nav]);

  if (!allowed) return null;
  return <AdminScreen />;
}

export const Route = createFileRoute("/_app/admin")({
  component: AdminGuard,
});
